<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        width="20"
        height="20"
        fill="currentColor"
    >
        <path
            d="M10 3.5c-4.14 0-7.68 2.61-9.06 6.28a.75.75 0 0 0 0 .44C2.32 13.89 5.86 16.5 10 16.5s7.68-2.61 9.06-6.28a.75.75 0 0 0 0-.44C17.68 6.11 14.14 3.5 10 3.5Zm0 10.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
        />
        <path d="M10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
    </svg>
</template>

<script>
export default { name: "EyeIcon" };
</script>
